import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';
import { useData, useSocket } from '../../../providers/SocketContext.jsx'



function Blur({isGameState}) {
    const socket = useSocket()
    const [isMultiplier, setIsMultiplier] = useState(null)
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [isBlur, setIsBlur] = useState(false);
    const [isBlur2, setIsBlur2] = useState(false);
    const [isBlur3, setIsBlur3] = useState(false);
    const containerRef = useRef(null);
    useEffect(() => {
        if (!socket) {
            return
        };
    
        const handleData = (res) => {
            setIsMultiplier(res.value);
            
        };
    
        socket.on('data', handleData);
    
        return () => {
            socket.off('data', handleData); // Удаляем тот же обработчик
        };
    }, [isGameState, socket]);
    

    


    useEffect(() => {
        
        if(isMultiplier < 2.00) {
            if(!isBlur) {
                setIsBlur(true)
            }
            if(isBlur2) {
                setIsBlur2(false)
            }
            if(isBlur3) {
                setIsBlur3(false)
            }
            

        }
        if(isMultiplier >= 2.00 && isMultiplier < 10.00) {
            if(!isBlur2) {
                setIsBlur2(true)
            }
            if(isBlur) {
                setIsBlur(false)
            }
            if(isBlur3) {
                setIsBlur3(false)
            }
        }

        if(isMultiplier >= 10.00) {
            if(!isBlur3) {
                setIsBlur3(true)
            }
            if(isBlur) {
                setIsBlur(false)
            }
            if(isBlur2) {
                setIsBlur2(false)
            }
        }

        
    }, [isMultiplier])

    const handleImageLoad = () => {
        setIsImageLoaded(true);
      };

    return (
        <>
            
            <div className={'blur-container-wrap'} ref={containerRef}>
                <img src={"/assets/img/blur1.svg"} className={isBlur && isImageLoaded && (isGameState === "active") ? 'fade-in' : ""}
          onLoad={handleImageLoad} alt="" />
            <img src={"/assets/img/blur2.svg"} className={isBlur2 && isImageLoaded && (isGameState === "active") ? 'fade-in' : ""}/>
            <img src={"/assets/img/blur3.svg"} className={isBlur3 && isImageLoaded && (isGameState === "active") ? 'fade-in' : ""}/>
            </div>
        </>
    )
}

export default Blur;